export default __webpack_public_path__ + "static/power-management-8e081af97d2e67242223fa48fc42d38f.jpg";